export default {"src":"/_next/static/media/spaghettisquash.19ecfe34.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};